import { render, staticRenderFns } from "./RaceFeature.vue?vue&type=template&id=85c628b0&scoped=true&"
import script from "./RaceFeature.vue?vue&type=script&lang=js&"
export * from "./RaceFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c628b0",
  null
  
)

export default component.exports